export const FRAGMENT_ASSET_GROUPS = `
assetGroups {
    name
    code
}
`;

// TODO: чуть позже PERIOD должен добавиться в FRAGMENT_DIVIDENDS
export const FRAGMENT_DIVIDENDS_PERIOD = `
period {
    month
    quarter
    months
    halfyear
    year
    other
}`;

export const FRAGMENT_DIVIDENDS = `
dividends { 
    closeDate
    payDate
    lastDate
    profitability
    type
    value
    currency
}`;

export const FRAGMENT_BOND_COUPONS = `
coupons {
    payment
    maturityDate
}`;

export const FRAGMENT_TYPE_SPECIFIC_PROPERTIES_DTO = `
typeSpecificPropertiesDto {
    lot
    bondOfferDate
    bondMaturityDate
    couponFaceValue
    ${FRAGMENT_BOND_COUPONS}
    ${FRAGMENT_DIVIDENDS}
}`;

export const FRAGMENT_ASSET_TYPE = `
assetType {
    name
    code
}`;

export const FRAGMENT_CURRENCY_DTO = `
currencyObj {
    name
    code
    symbol
}`;

export const FRAGMENT_PROFITABILITY_LIST = `
profitabilities {
    type
    profitability
    profitabilityPercent
}`;

export const FRAGMENT_PAGINATION = `
    limit
    offset
    sort
    totalCount
`;
